import { render, staticRenderFns } from "./ImagenCompania.vue?vue&type=template&id=e72577dc&scoped=true"
import script from "./ImagenCompania.vue?vue&type=script&lang=js"
export * from "./ImagenCompania.vue?vue&type=script&lang=js"
import style0 from "./ImagenCompania.vue?vue&type=style&index=0&id=e72577dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_css-loader@6.11.0_webpack@5.107.2_postcss@8_ff446875d22e2f3af5a28e88f68f10a6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72577dc",
  null
  
)

export default component.exports